import { get, writable } from "svelte/store";
import { appManager } from "../../../AppManager";
export class CommitsToolBoxManager {
    constructor(parent, toolBoxManager) {
        this.visibleStore = writable(false);
        this.historyStore = writable(undefined);
        this.layerId = "commits";
        this.parent = parent;
        this.toolBoxManager = toolBoxManager;
        this.parent.getBranchCommitIdStore().subscribe(() => {
            this.getCommits();
        });
        this.visibleStore.subscribe(v => {
            if (typeof this.map === "undefined")
                return;
            if (v) {
                this.map.showLayer(this.layerId);
            }
            else {
                this.map.hideLayer(this.layerId);
            }
        });
        this.parent.getScenarioDataStore().subscribe(() => {
            this.getCommits();
        });
        this.toolBoxManager.getOpenToolBoxStore().subscribe((name) => {
            if (name == this.layerId)
                this.getCommits();
        });
    }
    async forkToNewScenario(commit) {
        const scenario = get(this.parent.getScenarioDataStore());
        const projectData = await appManager.api.projects.getProject({
            accessToken: await appManager.api.getAccessToken(),
            id: scenario.project.id
        });
        const newBranch = await appManager.api.edit.createBranch({
            accessToken: await appManager.api.getAccessToken(),
            branchId: scenario.branchId,
            branchCommitId: commit.id
        });
        let highest = 0;
        projectData.scenarios.forEach(s => {
            const current = Number(s.functionalName);
            if (current <= highest)
                return;
            highest = current;
        });
        let newFunctionalName = `${highest + 1}`;
        let newName = `Scenario from commit: ${commit.comment}`;
        const newScenario = await appManager.api.projects.createScenario({
            accessToken: await appManager.api.getAccessToken(),
            data: {
                branchId: newBranch.id,
                description: scenario.description,
                functionalName: newFunctionalName,
                projectId: projectData.id,
                name: newName,
                tripScenarioId: scenario.tripScenarioModel.id,
            }
        });
        window.open(`${appManager.PublicUrl}/scenario/${newScenario.id}`, '_blank').focus();
    }
    async initializeAsync() {
        await this.getCommitsAsync();
    }
    getHistoryStore() {
        return this.historyStore;
    }
    getVisibleStore() {
        return this.visibleStore;
    }
    getOpenToolBoxStore() {
        return this.toolBoxManager.getOpenToolBoxStore();
    }
    addToMap(map) {
        this.map = map;
        this.addLayers();
    }
    addLayers() {
        if (this.map.hasLayer(this.layerId))
            return;
        // add maxspeed layer.
        this.map.addLayer({
            id: this.layerId,
            type: "line",
            source: this.parent.getCustomSourceId(),
            "source-layer": "transportation",
            paint: {
                "line-width": 30,
                "line-color": "#0000ff",
                "line-blur": 10,
                "line-opacity": 0.2
            },
            layout: {
                visibility: get(this.visibleStore) ? "visible" : "none",
            },
            filter: [
                "has",
                "_branch_commit_id",
            ],
        }, "road");
    }
    getCommits() {
        this.getCommitsAsync().then();
    }
    async getCommitsAsync() {
        const scenario = get(this.parent.getScenarioDataStore());
        if (typeof scenario === "undefined")
            return;
        const branchId = scenario.branchId;
        this.historyStore.set(await appManager.api.edit.getCommitsInfo({
            branchId,
            accessToken: await appManager.api.getAccessToken()
        }));
    }
}
